import React from 'react';
import styles from './AuditTrail.module.css';

const AuditHeader = ({ onExport, loading }) => {
    return (
        <div className={styles.header}>
            <div>
                <h1 className={styles.title}>Audit Trail</h1>
                <p className={styles.subtitle}>Complete system activity and security logs</p>
            </div>
            <button
                className={styles.exportButton}
                onClick={onExport}
                disabled={loading}
            >
                <span className={styles.buttonIcon}>↓</span>
                {loading ? 'Exporting...' : 'Export Logs'}
            </button>
        </div>
    );
};

export default AuditHeader;